<template>
    <div>
		<div class="page-filter-box">
		    <el-row :gutter="20">
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-input v-model="params.channelKey" class="input-with-select" size="small" placeholder="请输入渠道Key">
					</el-input>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-input v-model="params.channelName" class="input-with-select" size="small" placeholder="请输入渠道名称">
					</el-input>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.status" placeholder="请选择" size="small">
				        <el-option label="仅看启用的" :value="1"></el-option>
				        <el-option label="仅看禁用的" :value="0"></el-option>
						<el-option label="不限制状态" value=""></el-option>
				    </el-select>
				</el-col>
		        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
		            <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
		            <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
		        </el-col>
		    </el-row>
		</div>
        <div class="page-btns-box">
            <el-button
                type="primary"
                icon="el-icon-circle-plus-outline"               
                size="small"
				@click="add"
				v-if="$utils.have('/content/channel/manage/saveOrUpdate')"
                >新增内容渠道</el-button
            >
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="thirdName" label="渠道名称"></el-table-column>
				<el-table-column prop="status" label="状态">
					<template slot-scope="scope">
					    <span v-if="scope.row.status==0 ">禁用</span>
					    <span v-else-if="scope.row.status==1">启用</span>
					</template>
				</el-table-column>
				<el-table-column prop="serviceFee" label="默认服务费比例">
					<template slot-scope="scope">
						<span v-if="scope.row.serviceFee">{{scope.row.serviceFee}}%</span>
					</template>
				</el-table-column>
				<el-table-column prop="activityNum" label="演出数"></el-table-column>
				<el-table-column prop="saleAmount" label="总销售额"></el-table-column>
				<el-table-column prop="saleNum" label="总售票数"></el-table-column>
				<el-table-column prop="channelDomain" label="对接域名" min-width="150" show-overflow-tooltip></el-table-column>
				<el-table-column prop="channelCode" label="云仓渠道Code"></el-table-column>
				<el-table-column prop="modifyUserName" label="更新操作人"></el-table-column>
				<el-table-column prop="modifyTime" label="更新时间" min-width="110"></el-table-column>
                <el-table-column v-if="$utils.have('/content/channel/manage/saveOrUpdate')" fixed="right" label="操作" width="120">
                    <template slot-scope="scope">                        
                        <el-button
                            v-if="$utils.have('/content/channel/manage/saveOrUpdate')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
							@click="edit(scope.row.id)"
                            >管理</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0"
            >
            </el-pagination>
        </div>
		
    </div>
</template>
<script>
const defaultParams = {
    pageNo: 1,
    status:'',
	channelKey:'',
	channelName:''
}
export default {
	components: {  },
    data() {
        return {
            data: null,
            dataList: null,
            params: {
				...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0])				
            },
            listLoading: true,
        };
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/content/channel/manage/pageList",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        
		//选择pageSize
		handleSizeChange(e) {
		    this.params.pageNo = 1;
		    this.params.pageSize = e;
		    this.getDataList();
		},
		//搜索
		search() {
		    this.params.pageNo = 1;
		    this.getDataList();
		},
		//重置搜索
		reset() {
		    this.params = {
		        ...defaultParams,
		        pageSize: this.params.pageSize,
		    }
		    this.getDataList();
		},
        //新增事件
        add(){
            this.$router.push('/system/channel/add');    	
        },
        //编辑事件
        edit(id) {
           this.$router.push({
               path:`/system/channel/edit/${id}`,
               query: {
                   redirect: this.$utils.objArgs(
                       this.$router.currentRoute.path,
                       this.params
                   ),
               },
           });
        },
        
    },
};
</script>